import { inject, Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { ISvcChipGroupedOption, ISvcChipOption } from '@solvace/component/svc-controls/svc-chip';
import { ISvcSelectOption } from '@solvace/component/svc-controls';
import { UserService } from '@solvace/core/features/user/services/user.service';
import { UserHashtagsService } from '@solvace/core/features/user/user-hashtags/services/user-hastags.service';
import { SvcMasterdataService } from '@solvace/core/services/svc-masterdata.service';

const ALL_ACTIVE_TEAMS = { pageSize: 9999999, pageIndex: 1, name: '', active: true };

@Injectable()
export class SvcFormCustomFieldOptionsService {
  readonly #userService = inject(UserService);
  readonly #hashtagsService = inject(UserHashtagsService);
  readonly #masterdataService = inject(SvcMasterdataService);

  public getTeamOptions(): Observable<ISvcChipOption[]> {
    return this.#userService.getTeamsInfo(ALL_ACTIVE_TEAMS).pipe(map((response) => (response?.teams ?? []).map((team) => ({ label: team.name, value: String(team.teamId) }))));
  }

  public getHashtagOptions(siteId: number): Observable<ISvcChipGroupedOption[]> {
    return this.#hashtagsService.getGroupedHashtags(siteId, true, true).pipe(map((groups) => this.#withStringValues(groups ?? [])));
  }

  public getEquipmentOptions(locationIds: number[]): Observable<ISvcSelectOption[]> {
    const uniqueLocationIds = [...new Set((locationIds ?? []).map(Number).filter((id) => Number.isFinite(id) && id > 0))];
    if (!uniqueLocationIds.length) return of([]);

    return this.#masterdataService
      .getEquipmentsByLocations(uniqueLocationIds)
      .pipe(map((equipments) => (equipments ?? []).map((equipment) => ({ text: equipment.equipmentName, value: String(equipment.equipmentId) }))));
  }

  #withStringValues(groups: ISvcChipGroupedOption[]): ISvcChipGroupedOption[] {
    return groups.map((group) => ({
      ...group,
      options: (group.options ?? []).map((option) =>
        'options' in option ? this.#withStringValues([option as ISvcChipGroupedOption])[0] : { ...(option as ISvcChipOption), value: String((option as ISvcChipOption).value) }
      ),
    }));
  }
}
